<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />
    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <div class="col-sm-3 col-md-2">
            <div class="form-group">
              <label for="">面談地點</label>
              <el-input
                clearable
                placeholder="請輸入關鍵字"
                v-model.trim="search.keyword"
              />
            </div>
          </div>
          <div class="col-sm-3 col-md-4">
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-left: 10px"
              @click="getInterviewPlace"
            >
              {{ i18n("Buttons.Search") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-left: 10px"
              data-toggle="modal"
              data-target="#interviewPlaceModal"
              @click="interviewPlaceModal({ action: 'add' })"
            >
              {{ i18n("Buttons.Add") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="yahome-table-wrap">
      <VueBootstrap4Table
        :rows="rows"
        :columns="columns"
        :config="config"
        :total-rows="totalData"
        @on-change-query="changePage"
      >
        <template slot="Edit" slot-scope="props">
          <button
            type="button"
            class="btn btn-info btn-sm"
            data-toggle="modal"
            data-target="#interviewPlaceModal"
            @click="interviewPlaceModal({ action: 'edit', data: props.row })"
          >
            {{ i18n("Buttons.Edit") }}
          </button>
        </template>
        <template slot="Delete" slot-scope="props">
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-toggle="modal"
            data-target="#delInterviewPlaceModal"
            @click="interviewPlace = { ...props.row }"
          >
            {{ i18n("Buttons.Delete") }}
          </button>
        </template>
        <template slot="empty-results"> 暫無資料 </template>
      </VueBootstrap4Table>
    </div>

    <!-- 新增、編輯 Modal -->
    <div
      id="interviewPlaceModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver
          ref="interviewPlace"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @reset.prevent="reset">
            <div class="modal-header">
              <span v-if="action === 'add'">新增面談地點</span>
              <span v-else>編輯面談地點</span>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <ValidationProvider
                  name="面談地點"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="">
                    <span class="mark">*</span>
                    面談地點
                  </label>
                  <el-input clearable v-model.trim="interviewPlace.Name" />
                  <span v-if="errors[0] && !is_composing" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="handleSubmit(saveWorkplace)"
              >
                {{ i18n("Buttons.Save") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 刪除 Modal -->
    <div
      id="delInterviewPlaceModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">刪除面談地點</div>
          <div class="modal-body">
            確認刪除
            <span style="font-weight: bolder; color: red">
              {{ interviewPlace.Name }}
            </span>
            ?
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              {{ i18n("Buttons.Cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="delWorkplace"
            >
              {{ i18n("Buttons.Delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import { config } from "@/components/back/table_config.js";

export default {
  name: "WorkPlaceMaintenance",

  data() {
    return {
      // compositionstart& compositionend
      is_composing: false,

      // 判斷新增、編輯
      action: "add",

      interviewPlace: {},

      search: {},

      rows: [],
      totalData: 0,

      // 分頁資訊
      tableInfo: {
        page: 1,
        per_page: 10,
      },

      columns: [
        {
          label: "面談地點",
          name: "Name",
        },
        {
          label: "",
          name: "Edit",
          slot_name: "Edit",
        },
        {
          label: "",
          name: "Delete",
          slot_name: "Delete",
        },
      ],

      config: {
        ...config,
        server_mode: true,
      },
    };
  },

  methods: {
    // 換頁
    changePage(queryParams) {
      this.tableInfo = queryParams;
      this.getInterviewPlace();
    },

    // 取得 面談地點
    getInterviewPlace() {
      this.updateLoading(true);
      this.$api.interviewPlace
        .getInterviewPlacePaging({
          ...this.search,
          page: this.tableInfo.page,
          perPage: this.tableInfo.per_page,
        })
        .then((response) => {
          if (response.status === 200) {
            this.rows = response.data.Data;
            this.totalData = response.data.SearchQuantity;
          }
          this.updateLoading(false);
        });
    },

    // 面談地點 Modal
    interviewPlaceModal({ action, data }) {
      switch (action) {
        case "add":
          this.interviewPlace = {};
          this.action = "add";
          break;
        case "edit":
          this.interviewPlace = { ...data };
          this.action = "edit";
          break;
      }
      this.$refs.interviewPlace.reset();
    },

    // 新增、編輯 面談地點
    saveWorkplace() {
      $("#interviewPlaceModal").modal("hide");
      this.updateLoading(true);
      switch (this.action) {
        case "add":
          this.$api.interviewPlace
            .postInterviewPlace({
              ...this.interviewPlace,
              CreateUser: this.$cookies.get("userId"),
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: "新增成功",
                  type: "success",
                  duration: 2000,
                });
                this.getInterviewPlace();
              }
              this.updateLoading(false);
            });
          break;
        case "edit":
          this.$api.interviewPlace
            .putInterviewPlace({
              ...this.interviewPlace,
              UpdateUser: this.$cookies.get("userId"),
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: "編輯成功",
                  type: "success",
                  duration: 2000,
                });
                this.getInterviewPlace();
              }
              this.updateLoading(false);
            });
          break;
      }
    },

    // 刪除 面談地點
    delWorkplace() {
      this.updateLoading(true);
      this.$api.interviewPlace
        .deleteInterviewPlace({
          Guid: this.interviewPlace.Guid,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "刪除成功",
              type: "success",
              duration: 2000,
            });
            this.getInterviewPlace();
          }
          this.updateLoading(false);
        });
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>
